import {
  cancelActiveParentConnectMockHandler,
  cancelAndRebookParentConnectMockHandler,
} from '@/features/parent-connect-cancel-reschedule';

// Mocks for the trainer-initiated active parent-connect cancel /
// cancel-and-reschedule flow (`/parent-connect/cancel-reschedule` +
// `/parent-connect/cancel-rebook`). The session-context fetch and the
// slot-listing query are already mocked under parent-connect-edit-request
// + parent-connect-booking (same endpoints), so we only need the two
// new submit endpoints here.
export const parentConnectCancelRescheduleHandlers = [
  cancelActiveParentConnectMockHandler,
  cancelAndRebookParentConnectMockHandler,
];
